<template>
    <div>
        <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options"/>
        <basic-table
            v-if="recurrentPayments"
            :items="recurrentPayments"
            :fields="fields"
            @ClickOnDeleteButton="ClickOnDeleteButton"
            @ClickOnEditButton="editItem"
            :filter="filter"
            :perPage="perPage"
            :currentPage="currentPage"
            v-model="totalRows"
            isDelete="true"
            :isEdit="false"/>
        <table-manager-bottom
            :totalRows="totalRows" :perPage="perPage"
            v-model="currentPage"/>
    </div>
</template>
<script>
export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'customer_id', label: this.$i18n.t('Customer ID'), sortable: true},
        {key: 'account_id', label: this.$i18n.t('Account ID'), sortable: true},
        {key: 'charge_min_balance', label: this.$i18n.t('Charge min balance'), sortable: true},
        {key: 'payment_system_type', label: this.$i18n.t('Payment system type'), sortable: true},
        {key: 'payment_system_name', label: this.$i18n.t('Payment system'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedAvailReps: null,
      options: {
        isShowAddButton: false
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      reportsArray: []
    }
  },
  methods: {
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Recurrent payments?"', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Users/DELETE_RECURRENT_PAYMENTS', item.customer_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_RECURRENT_PAYMENTS', 0)
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    recurrentPayments () {
      return this.$store.getters['Users/RECURRENT_PAYMENTS']
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_RECURRENT_PAYMENTS', 0)
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/paymentSystems/RecurrentPayments.vue